/* eslint-disable */
import * as Types from '../types.generated';

import {
    OwnershipFieldsFragment,
    EntityDomainFragment,
    TypeOfRelationsFieldsFragment,
    ParentNodesFieldsFragment,
    StructuredPropertiesFieldsFragment,
    InstitutionalMemoryFieldsFragment,
    GlobalTagsFieldsFragment,
    GlossaryTermsFragment,
    GlossaryNodeFragment,
    GlossaryTermFragment,
} from './fragments.generated';
import { gql } from '@apollo/client';
import {
    OwnershipFieldsFragmentDoc,
    EntityDomainFragmentDoc,
    TypeOfRelationsFieldsFragmentDoc,
    ParentNodesFieldsFragmentDoc,
    StructuredPropertiesFieldsFragmentDoc,
    InstitutionalMemoryFieldsFragmentDoc,
    GlobalTagsFieldsFragmentDoc,
    GlossaryTermsFragmentDoc,
    GlossaryNodeFragmentDoc,
    GlossaryTermFragmentDoc,
} from './fragments.generated';
import * as Apollo from '@apollo/client';
export type ChildGlossaryTermFragment = { __typename?: 'GlossaryTerm' } & Pick<
    Types.GlossaryTerm,
    'urn' | 'type' | 'name' | 'hierarchicalName'
> & {
        properties?: Types.Maybe<
            { __typename?: 'GlossaryTermProperties' } & Pick<Types.GlossaryTermProperties, 'name'>
        >;
    };

export type GetGlossaryNodeQueryVariables = Types.Exact<{
    urn: Types.Scalars['String'];
}>;

export type GetGlossaryNodeQuery = { __typename?: 'Query' } & {
    glossaryNode?: Types.Maybe<
        { __typename?: 'GlossaryNode' } & Pick<Types.GlossaryNode, 'urn' | 'type' | 'exists'> & {
                subTypes?: Types.Maybe<{ __typename?: 'SubTypes' } & Pick<Types.SubTypes, 'typeNames'>>;
                GovernanceStatusInfo?: Types.Maybe<
                    { __typename?: 'GovernanceStatus' } & Pick<
                        Types.GovernanceStatus,
                        'displayName' | 'doc' | 'status'
                    > & {
                            created: { __typename?: 'AuditStamp' } & Pick<Types.AuditStamp, 'actor' | 'time'> & {
                                    actorInfo?: Types.Maybe<
                                        { __typename?: 'CorpUser' } & {
                                            info?: Types.Maybe<
                                                { __typename?: 'CorpUserInfo' } & Pick<
                                                    Types.CorpUserInfo,
                                                    'fullName' | 'email' | 'displayName'
                                                >
                                            >;
                                        }
                                    >;
                                };
                        }
                >;
                properties?: Types.Maybe<
                    { __typename?: 'GlossaryNodeProperties' } & Pick<
                        Types.GlossaryNodeProperties,
                        'name' | 'description'
                    > & {
                            customProperties?: Types.Maybe<
                                Array<
                                    { __typename?: 'CustomPropertiesEntry' } & Pick<
                                        Types.CustomPropertiesEntry,
                                        'key' | 'value' | 'isEditable'
                                    >
                                >
                            >;
                        }
                >;
                ownership?: Types.Maybe<{ __typename?: 'Ownership' } & OwnershipFieldsFragment>;
                domain?: Types.Maybe<{ __typename?: 'DomainAssociation' } & EntityDomainFragment>;
                typeOfRelations?: Types.Maybe<{ __typename?: 'TypeOfRelationResult' } & TypeOfRelationsFieldsFragment>;
                parentNodes?: Types.Maybe<{ __typename?: 'ParentNodesResult' } & ParentNodesFieldsFragment>;
                privileges?: Types.Maybe<
                    { __typename?: 'EntityPrivileges' } & Pick<
                        Types.EntityPrivileges,
                        'canManageEntity' | 'canManageChildren'
                    >
                >;
                governanceFlags?: Types.Maybe<
                    { __typename?: 'GovernanceFlags' } & {
                        flags?: Types.Maybe<
                            Array<
                                Types.Maybe<
                                    { __typename?: 'GovernanceFlagDetails' } & Pick<
                                        Types.GovernanceFlagDetails,
                                        'doc' | 'name' | 'value'
                                    > & {
                                            auditStamp?: Types.Maybe<
                                                { __typename?: 'AuditStamp' } & Pick<
                                                    Types.AuditStamp,
                                                    'actor' | 'time'
                                                > & {
                                                        actorInfo?: Types.Maybe<
                                                            { __typename?: 'CorpUser' } & {
                                                                info?: Types.Maybe<
                                                                    { __typename?: 'CorpUserInfo' } & Pick<
                                                                        Types.CorpUserInfo,
                                                                        'fullName' | 'email' | 'displayName'
                                                                    >
                                                                >;
                                                            }
                                                        >;
                                                    }
                                            >;
                                        }
                                >
                            >
                        >;
                    }
                >;
                structuredProperties?: Types.Maybe<
                    { __typename?: 'StructuredProperties' } & {
                        properties?: Types.Maybe<
                            Array<{ __typename?: 'StructuredPropertiesEntry' } & StructuredPropertiesFieldsFragment>
                        >;
                    }
                >;
                children?: Types.Maybe<
                    { __typename?: 'EntityRelationshipsResult' } & Pick<Types.EntityRelationshipsResult, 'total'> & {
                            relationships: Array<
                                { __typename?: 'EntityRelationship' } & Pick<Types.EntityRelationship, 'direction'> & {
                                        entity?: Types.Maybe<
                                            | ({ __typename?: 'AccessTokenMetadata' } & Pick<
                                                  Types.AccessTokenMetadata,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'Assertion' } & Pick<Types.Assertion, 'type' | 'urn'>)
                                            | ({ __typename?: 'Chart' } & Pick<Types.Chart, 'type' | 'urn'>)
                                            | ({ __typename?: 'Container' } & Pick<Types.Container, 'type' | 'urn'>)
                                            | ({ __typename?: 'CorpGroup' } & Pick<Types.CorpGroup, 'type' | 'urn'>)
                                            | ({ __typename?: 'CorpUser' } & Pick<Types.CorpUser, 'type' | 'urn'>)
                                            | ({ __typename?: 'Dashboard' } & Pick<Types.Dashboard, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataFlow' } & Pick<Types.DataFlow, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataHubPolicy' } & Pick<
                                                  Types.DataHubPolicy,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'DataHubRole' } & Pick<Types.DataHubRole, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataHubView' } & Pick<Types.DataHubView, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataJob' } & Pick<Types.DataJob, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataPlatform' } & Pick<
                                                  Types.DataPlatform,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'DataPlatformInstance' } & Pick<
                                                  Types.DataPlatformInstance,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'DataProcessInstance' } & Pick<
                                                  Types.DataProcessInstance,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'DataProduct' } & Pick<Types.DataProduct, 'type' | 'urn'>)
                                            | ({ __typename?: 'DataTypeEntity' } & Pick<
                                                  Types.DataTypeEntity,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'Dataset' } & Pick<Types.Dataset, 'type' | 'urn'>)
                                            | ({ __typename?: 'Domain' } & Pick<Types.Domain, 'type' | 'urn'>)
                                            | ({ __typename?: 'EntityTypeEntity' } & Pick<
                                                  Types.EntityTypeEntity,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'GlossaryNode' } & Pick<
                                                  Types.GlossaryNode,
                                                  'type' | 'urn'
                                              > &
                                                  GlossaryNodeFragment)
                                            | ({ __typename?: 'GlossaryTerm' } & Pick<
                                                  Types.GlossaryTerm,
                                                  'type' | 'urn'
                                              > &
                                                  ChildGlossaryTermFragment)
                                            | ({ __typename?: 'MLFeature' } & Pick<Types.MlFeature, 'type' | 'urn'>)
                                            | ({ __typename?: 'MLFeatureTable' } & Pick<
                                                  Types.MlFeatureTable,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'MLModel' } & Pick<Types.MlModel, 'type' | 'urn'>)
                                            | ({ __typename?: 'MLModelGroup' } & Pick<
                                                  Types.MlModelGroup,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'MLPrimaryKey' } & Pick<
                                                  Types.MlPrimaryKey,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'Notebook' } & Pick<Types.Notebook, 'type' | 'urn'>)
                                            | ({ __typename?: 'OwnershipTypeEntity' } & Pick<
                                                  Types.OwnershipTypeEntity,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'Post' } & Pick<Types.Post, 'type' | 'urn'>)
                                            | ({ __typename?: 'QueryEntity' } & Pick<Types.QueryEntity, 'type' | 'urn'>)
                                            | ({ __typename?: 'Role' } & Pick<Types.Role, 'type' | 'urn'>)
                                            | ({ __typename?: 'SchemaFieldEntity' } & Pick<
                                                  Types.SchemaFieldEntity,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'StructuredPropertyEntity' } & Pick<
                                                  Types.StructuredPropertyEntity,
                                                  'type' | 'urn'
                                              >)
                                            | ({ __typename?: 'Tag' } & Pick<Types.Tag, 'type' | 'urn'>)
                                            | ({ __typename?: 'Test' } & Pick<Types.Test, 'type' | 'urn'>)
                                            | ({ __typename?: 'VersionedDataset' } & Pick<
                                                  Types.VersionedDataset,
                                                  'type' | 'urn'
                                              >)
                                        >;
                                    }
                            >;
                        }
                >;
                isTypeOf?: Types.Maybe<
                    { __typename?: 'EntityRelationshipsResult' } & Pick<
                        Types.EntityRelationshipsResult,
                        'start' | 'count' | 'total'
                    > & {
                            relationships: Array<
                                { __typename?: 'EntityRelationship' } & {
                                    entity?: Types.Maybe<
                                        | ({ __typename?: 'AccessTokenMetadata' } & Pick<
                                              Types.AccessTokenMetadata,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Assertion' } & Pick<Types.Assertion, 'type' | 'urn'>)
                                        | ({ __typename?: 'Chart' } & Pick<Types.Chart, 'type' | 'urn'>)
                                        | ({ __typename?: 'Container' } & Pick<Types.Container, 'type' | 'urn'>)
                                        | ({ __typename?: 'CorpGroup' } & Pick<Types.CorpGroup, 'type' | 'urn'>)
                                        | ({ __typename?: 'CorpUser' } & Pick<Types.CorpUser, 'type' | 'urn'>)
                                        | ({ __typename?: 'Dashboard' } & Pick<Types.Dashboard, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataFlow' } & Pick<Types.DataFlow, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubPolicy' } & Pick<Types.DataHubPolicy, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubRole' } & Pick<Types.DataHubRole, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubView' } & Pick<Types.DataHubView, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataJob' } & Pick<Types.DataJob, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataPlatform' } & Pick<Types.DataPlatform, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataPlatformInstance' } & Pick<
                                              Types.DataPlatformInstance,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'DataProcessInstance' } & Pick<
                                              Types.DataProcessInstance,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'DataProduct' } & Pick<Types.DataProduct, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataTypeEntity' } & Pick<
                                              Types.DataTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Dataset' } & Pick<Types.Dataset, 'type' | 'urn'>)
                                        | ({ __typename?: 'Domain' } & Pick<Types.Domain, 'type' | 'urn'>)
                                        | ({ __typename?: 'EntityTypeEntity' } & Pick<
                                              Types.EntityTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'GlossaryNode' } & Pick<Types.GlossaryNode, 'type' | 'urn'> &
                                              GlossaryNodeFragment)
                                        | ({ __typename?: 'GlossaryTerm' } & Pick<Types.GlossaryTerm, 'type' | 'urn'> &
                                              GlossaryTermFragment)
                                        | ({ __typename?: 'MLFeature' } & Pick<Types.MlFeature, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLFeatureTable' } & Pick<
                                              Types.MlFeatureTable,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'MLModel' } & Pick<Types.MlModel, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLModelGroup' } & Pick<Types.MlModelGroup, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLPrimaryKey' } & Pick<Types.MlPrimaryKey, 'type' | 'urn'>)
                                        | ({ __typename?: 'Notebook' } & Pick<Types.Notebook, 'type' | 'urn'>)
                                        | ({ __typename?: 'OwnershipTypeEntity' } & Pick<
                                              Types.OwnershipTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Post' } & Pick<Types.Post, 'type' | 'urn'>)
                                        | ({ __typename?: 'QueryEntity' } & Pick<Types.QueryEntity, 'type' | 'urn'>)
                                        | ({ __typename?: 'Role' } & Pick<Types.Role, 'type' | 'urn'>)
                                        | ({ __typename?: 'SchemaFieldEntity' } & Pick<
                                              Types.SchemaFieldEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'StructuredPropertyEntity' } & Pick<
                                              Types.StructuredPropertyEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Tag' } & Pick<Types.Tag, 'type' | 'urn'>)
                                        | ({ __typename?: 'Test' } & Pick<Types.Test, 'type' | 'urn'>)
                                        | ({ __typename?: 'VersionedDataset' } & Pick<
                                              Types.VersionedDataset,
                                              'type' | 'urn'
                                          >)
                                    >;
                                }
                            >;
                        }
                >;
                hasRelatedTerms?: Types.Maybe<
                    { __typename?: 'EntityRelationshipsResult' } & Pick<
                        Types.EntityRelationshipsResult,
                        'start' | 'count' | 'total'
                    > & {
                            relationships: Array<
                                { __typename?: 'EntityRelationship' } & {
                                    entity?: Types.Maybe<
                                        | ({ __typename?: 'AccessTokenMetadata' } & Pick<
                                              Types.AccessTokenMetadata,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Assertion' } & Pick<Types.Assertion, 'type' | 'urn'>)
                                        | ({ __typename?: 'Chart' } & Pick<Types.Chart, 'type' | 'urn'>)
                                        | ({ __typename?: 'Container' } & Pick<Types.Container, 'type' | 'urn'>)
                                        | ({ __typename?: 'CorpGroup' } & Pick<Types.CorpGroup, 'type' | 'urn'>)
                                        | ({ __typename?: 'CorpUser' } & Pick<Types.CorpUser, 'type' | 'urn'>)
                                        | ({ __typename?: 'Dashboard' } & Pick<Types.Dashboard, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataFlow' } & Pick<Types.DataFlow, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubPolicy' } & Pick<Types.DataHubPolicy, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubRole' } & Pick<Types.DataHubRole, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataHubView' } & Pick<Types.DataHubView, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataJob' } & Pick<Types.DataJob, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataPlatform' } & Pick<Types.DataPlatform, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataPlatformInstance' } & Pick<
                                              Types.DataPlatformInstance,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'DataProcessInstance' } & Pick<
                                              Types.DataProcessInstance,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'DataProduct' } & Pick<Types.DataProduct, 'type' | 'urn'>)
                                        | ({ __typename?: 'DataTypeEntity' } & Pick<
                                              Types.DataTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Dataset' } & Pick<Types.Dataset, 'type' | 'urn'>)
                                        | ({ __typename?: 'Domain' } & Pick<Types.Domain, 'type' | 'urn'>)
                                        | ({ __typename?: 'EntityTypeEntity' } & Pick<
                                              Types.EntityTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'GlossaryNode' } & Pick<Types.GlossaryNode, 'type' | 'urn'>)
                                        | ({ __typename?: 'GlossaryTerm' } & Pick<Types.GlossaryTerm, 'type' | 'urn'> &
                                              GlossaryTermFragment)
                                        | ({ __typename?: 'MLFeature' } & Pick<Types.MlFeature, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLFeatureTable' } & Pick<
                                              Types.MlFeatureTable,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'MLModel' } & Pick<Types.MlModel, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLModelGroup' } & Pick<Types.MlModelGroup, 'type' | 'urn'>)
                                        | ({ __typename?: 'MLPrimaryKey' } & Pick<Types.MlPrimaryKey, 'type' | 'urn'>)
                                        | ({ __typename?: 'Notebook' } & Pick<Types.Notebook, 'type' | 'urn'>)
                                        | ({ __typename?: 'OwnershipTypeEntity' } & Pick<
                                              Types.OwnershipTypeEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Post' } & Pick<Types.Post, 'type' | 'urn'>)
                                        | ({ __typename?: 'QueryEntity' } & Pick<Types.QueryEntity, 'type' | 'urn'>)
                                        | ({ __typename?: 'Role' } & Pick<Types.Role, 'type' | 'urn'>)
                                        | ({ __typename?: 'SchemaFieldEntity' } & Pick<
                                              Types.SchemaFieldEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'StructuredPropertyEntity' } & Pick<
                                              Types.StructuredPropertyEntity,
                                              'type' | 'urn'
                                          >)
                                        | ({ __typename?: 'Tag' } & Pick<Types.Tag, 'type' | 'urn'>)
                                        | ({ __typename?: 'Test' } & Pick<Types.Test, 'type' | 'urn'>)
                                        | ({ __typename?: 'VersionedDataset' } & Pick<
                                              Types.VersionedDataset,
                                              'type' | 'urn'
                                          >)
                                    >;
                                }
                            >;
                        }
                >;
                isRelatedTerms?: Types.Maybe<
                    { __typename?: 'EntityRelationshipsResult' } & Pick<
                        Types.EntityRelationshipsResult,
                        'start' | 'count' | 'total'
                    > & {
                            relationships: Array<
                                { __typename?: 'EntityRelationship' } & {
                                    entity?: Types.Maybe<
                                        | { __typename?: 'AccessTokenMetadata' }
                                        | { __typename?: 'Assertion' }
                                        | { __typename?: 'Chart' }
                                        | { __typename?: 'Container' }
                                        | { __typename?: 'CorpGroup' }
                                        | { __typename?: 'CorpUser' }
                                        | { __typename?: 'Dashboard' }
                                        | { __typename?: 'DataFlow' }
                                        | { __typename?: 'DataHubPolicy' }
                                        | { __typename?: 'DataHubRole' }
                                        | { __typename?: 'DataHubView' }
                                        | { __typename?: 'DataJob' }
                                        | { __typename?: 'DataPlatform' }
                                        | { __typename?: 'DataPlatformInstance' }
                                        | { __typename?: 'DataProcessInstance' }
                                        | { __typename?: 'DataProduct' }
                                        | { __typename?: 'DataTypeEntity' }
                                        | { __typename?: 'Dataset' }
                                        | { __typename?: 'Domain' }
                                        | { __typename?: 'EntityTypeEntity' }
                                        | { __typename?: 'GlossaryNode' }
                                        | ({ __typename?: 'GlossaryTerm' } & GlossaryTermFragment)
                                        | { __typename?: 'MLFeature' }
                                        | { __typename?: 'MLFeatureTable' }
                                        | { __typename?: 'MLModel' }
                                        | { __typename?: 'MLModelGroup' }
                                        | { __typename?: 'MLPrimaryKey' }
                                        | { __typename?: 'Notebook' }
                                        | { __typename?: 'OwnershipTypeEntity' }
                                        | { __typename?: 'Post' }
                                        | { __typename?: 'QueryEntity' }
                                        | { __typename?: 'Role' }
                                        | { __typename?: 'SchemaFieldEntity' }
                                        | { __typename?: 'StructuredPropertyEntity' }
                                        | { __typename?: 'Tag' }
                                        | { __typename?: 'Test' }
                                        | { __typename?: 'VersionedDataset' }
                                    >;
                                }
                            >;
                        }
                >;
            }
    >;
};

export const ChildGlossaryTermFragmentDoc = gql`
    fragment childGlossaryTerm on GlossaryTerm {
        urn
        type
        name
        hierarchicalName
        properties {
            name
        }
    }
`;
export const GetGlossaryNodeDocument = gql`
    query getGlossaryNode($urn: String!) {
        glossaryNode(urn: $urn) {
            urn
            type
            exists
            subTypes {
                typeNames
            }
            GovernanceStatusInfo {
                created {
                    actor
                    time
                    actorInfo {
                        info {
                            fullName
                            email
                            displayName
                        }
                    }
                }
                displayName
                doc
                status
            }
            properties {
                name
                description
                customProperties {
                    key
                    value
                    isEditable
                }
            }
            ownership {
                ...ownershipFields
            }
            domain {
                ...entityDomain
            }
            typeOfRelations {
                ...typeOfRelationsFields
            }
            parentNodes {
                ...parentNodesFields
            }
            privileges {
                canManageEntity
                canManageChildren
            }
            governanceFlags {
                flags {
                    auditStamp {
                        actor
                        time
                        actorInfo {
                            info {
                                fullName
                                email
                                displayName
                            }
                        }
                    }
                    doc
                    name
                    value
                }
            }
            structuredProperties {
                properties {
                    ...structuredPropertiesFields
                }
            }
            children: relationships(input: { types: ["IsPartOf"], direction: INCOMING, start: 0, count: 10000 }) {
                total
                relationships {
                    direction
                    entity {
                        type
                        urn
                        ... on GlossaryNode {
                            ...glossaryNode
                        }
                        ... on GlossaryTerm {
                            ...childGlossaryTerm
                        }
                    }
                }
            }
            isTypeOf: relationships(input: { types: ["IsTypeOf"], direction: INCOMING, start: 0, count: 10000 }) {
                start
                count
                total
                relationships {
                    entity {
                        type
                        urn
                        ... on GlossaryTerm {
                            ...glossaryTerm
                        }
                        ... on GlossaryNode {
                            ...glossaryNode
                        }
                    }
                }
            }
            hasRelatedTerms: relationships(input: { types: ["HasA"], direction: OUTGOING, start: 0, count: 10000 }) {
                start
                count
                total
                relationships {
                    entity {
                        type
                        urn
                        ... on GlossaryTerm {
                            ...glossaryTerm
                        }
                    }
                }
            }
            isRelatedTerms: relationships(input: { types: ["IsA"], direction: OUTGOING, start: 0, count: 10000 }) {
                start
                count
                total
                relationships {
                    entity {
                        ... on GlossaryTerm {
                            ...glossaryTerm
                        }
                    }
                }
            }
        }
    }
    ${OwnershipFieldsFragmentDoc}
    ${EntityDomainFragmentDoc}
    ${TypeOfRelationsFieldsFragmentDoc}
    ${ParentNodesFieldsFragmentDoc}
    ${StructuredPropertiesFieldsFragmentDoc}
    ${GlossaryNodeFragmentDoc}
    ${ChildGlossaryTermFragmentDoc}
    ${GlossaryTermFragmentDoc}
`;

/**
 * __useGetGlossaryNodeQuery__
 *
 * To run a query within a React component, call `useGetGlossaryNodeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGlossaryNodeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGlossaryNodeQuery({
 *   variables: {
 *      urn: // value for 'urn'
 *   },
 * });
 */
export function useGetGlossaryNodeQuery(
    baseOptions: Apollo.QueryHookOptions<GetGlossaryNodeQuery, GetGlossaryNodeQueryVariables>,
) {
    return Apollo.useQuery<GetGlossaryNodeQuery, GetGlossaryNodeQueryVariables>(GetGlossaryNodeDocument, baseOptions);
}
export function useGetGlossaryNodeLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<GetGlossaryNodeQuery, GetGlossaryNodeQueryVariables>,
) {
    return Apollo.useLazyQuery<GetGlossaryNodeQuery, GetGlossaryNodeQueryVariables>(
        GetGlossaryNodeDocument,
        baseOptions,
    );
}
export type GetGlossaryNodeQueryHookResult = ReturnType<typeof useGetGlossaryNodeQuery>;
export type GetGlossaryNodeLazyQueryHookResult = ReturnType<typeof useGetGlossaryNodeLazyQuery>;
export type GetGlossaryNodeQueryResult = Apollo.QueryResult<GetGlossaryNodeQuery, GetGlossaryNodeQueryVariables>;
